import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Popup, Heading } from 'components';

import classNames from 'classnames/bind';

import FormWrapper from './components/FormWrapper';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const MulticonvergenceOfferPopup = (props) => {
  const getSuccessMessageWithBid = () => {
    const { successMessage, userBidID } = props;

    return successMessage.replace('XXXX', userBidID);
  };

  const {
    activePopup, isOpened, closePopup, errorMessage, hasRequest, hasError, isSuccess,
  } = props;

  if (hasRequest && hasError) {
    return (
      <Popup
        onClose={closePopup}
        opened={isOpened}
      >
        <div className={cx('message')}>
          <Heading className={cx('subtitle')} level={5}>
            <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
          </Heading>
        </div>
      </Popup>
    );
  }

  if (hasRequest && isSuccess) {
    return (
      <Popup
        onClose={closePopup}
        opened={isOpened}
      >
        <div className={cx('message')}>
          <Heading className={cx('subtitle')} level={5}>
            <span dangerouslySetInnerHTML={{ __html: getSuccessMessageWithBid() }} />
          </Heading>
        </div>
      </Popup>
    );
  }

  if (activePopup === 'multiconvergenceOfferConnectionRequest') {
    return (
      <Popup
        onClose={closePopup}
        opened={isOpened}
      >
        <div className={cx('layout')}>
          <div className={cx('head')}>
            <Heading level={2} className={cx('heading')}>Заявка на подключение</Heading>
          </div>

          <FormWrapper />
        </div>
      </Popup>
    );
  }

  return null;
};

MulticonvergenceOfferPopup.propTypes = {
  activePopup: PropTypes.string,
  isOpened: PropTypes.bool,
  closePopup: PropTypes.func,
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  hasRequest: PropTypes.bool,
  hasError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  userBidID: PropTypes.string,
};

const mapStateToProps = (state) => {
  const requestData = state.home.allInOne.requestData || {};

  const hasRequest = Object.keys(requestData).length !== 0;
  const isSuccess = requestData.isSuccess || false;
  const hasError = hasRequest && !isSuccess;

  const bid = requestData.requestId || '';

  return ({
    activePopup: state.application.popup,

    errorMessage: state.home.profileSummary.data.multiconvergenceOffer.errorMessage,
    successMessage: state.home.profileSummary.data.multiconvergenceOffer.successMessage,

    hasRequest,
    isSuccess,
    hasError,
    userBidID: bid,
  });
};

export default connect(mapStateToProps)(MulticonvergenceOfferPopup);
